// tslint:disable:max-line-length

import React from "react";
import { Helmet } from "react-helmet";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { PageImageHeader } from "./../../components/pageImageHeader";

export const BecomeAPartner = () => (
  <div className="partner-up">
    <Helmet
      title="Become a partner"
      link={[
        {
          rel: "canonical",
          href: `${globalConfig.wwwBaseUrl}${WebRoutes.becomeAPartner()}`,
        },
      ]}
      meta={[
        {
          name: "description",
          content: "Would you like to become one of TravelLocal's local experts? We choose our partners really carefully, but once you're in, we will make it a partnership of friendship and trust. Find out more about how it works",
        },
      ]}
    />
    <PageImageHeader imageSrc="/images/locations/26.jpg" imageMeta="Summit of a snow covered mountain" title="Become a partner" spaceForTabs={false} />

    <div className="width-wrapper">
      <div className="main-content">
        <div className="intro">
          <p>Are you:</p>
          <ol>
            <li><p>Sat at your desk wondering why you're having to deal with big and boring international tour operators every day?</p></li>
            <li><p>Tired of being ground into the floor on price and compromising your creativity and originality?</p></li>
            <li><p>Wanting to tell the world about your incredible country, and to create amazing itineraries and experiences for clients?</p></li>
          </ol>
        </div>

        <h3>Then we might just be for you</h3>

        <p>You're a local company, taxed and registered in your home country or region. You know your patch like the back of your hand - every last bit of it.
        You are international in outlook, and you understand why travellers want to visit your country - and the different experiences which different types
        of clients want when they are there. You are incredibly well organised and you take huge pride in service standards. You take great  happiness and pride from finding out that some people from the other side of the world came to your country, travelled with your company and had an incredible, once in a lifetime trip.</p>

        <p>We are an online travel agency for local tour operators (LTOs) across the globe. We have customers from all over the world come to us trying to find something better - a more authentic trip, an insight into local life and a real connection with where they're going. Our partner local tour operators love our amazing online technology platform. They use it to communicate directly with clients online and create a fantastic online itinerary (viewable on all devices), which enables them to respond to enquiries easily and quickly.</p>

        <p>We choose our partners carefully, but once you're in we will make it a partnership of friendship and trust with you. We charge no fees except for an agreed commission rate. We will help you to grow your business and connect more closely with the people you most want to talk to - customers.</p>

        <p>If you think you fit what we want and you have some real spark and originality, then we’d love to hear from you. Get in touch directly with us and tell us more about what you do and how we can work together.</p>

        <p>We are open to approaches from LTO’s seeking to partner with us in any country worldwide. Please complete <a href="https://holidays.travellocal.com/become-a-partner/" target="_blank">this form</a> to send us details about your company.</p>
      </div>
    </div>
  </div>
);
